import { render } from "./DebtChart.vue?vue&type=template&id=52c9f070"
import script from "./DebtChart.vue?vue&type=script&lang=js"
export * from "./DebtChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/p878kMc7/0/softbot/pplotto/pplotto-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__